var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"events-calendar"},[(_vm.isLoading)?_c('div',{staticClass:"events-calendar__loader"}):_vm._e(),_vm._v(" "),_c('full-calendar',{ref:"calendarRef",attrs:{"options":Object.assign({}, _vm.caledarBaseOptions,
      {customButtons: {
        prev: { click: _vm.handleToolbarDirClick('prev') },
        next: { click: _vm.handleToolbarDirClick('next') }
      },
      events: _vm.events,
      windowResize: _vm.events_setPopoverClosed,
      titleFormat: _vm.getCalendarTitle,
      moreLinkContent: _vm.getMoreLinkContent,
      moreLinkClick: _vm.handleMoreClick,
      eventContent: _vm.getEventContent,
      eventBackgroundColor: 'green',
      eventClick: _vm.handleEventClick})}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/pages/events/components/events-calendar/events-calendar.vue?vue&type=template&id=71bc568d&
// module id = 956
// module chunks = 0